__turbopack_context__.v({
  "banner": "styles-module__LbKsJG__banner",
  "bannerText": "styles-module__LbKsJG__bannerText",
  "container": "styles-module__LbKsJG__container",
});
